import { useTranslation } from "react-i18next";
import { Card } from "primereact/card";
import { formatValueReais } from "../../../utils/ValidationUtils";

// Normaliza dd/MM/yyyy[ hh:mm], yyyy-MM-dd ou yyyyMMdd para yyyyMMdd (ordenável)
const chaveData = (valor: any): string | null => {
  if (!valor || typeof valor !== 'string') return null;
  const texto = valor.trim();
  let m = texto.match(/^(\d{2})\/(\d{2})\/(\d{4})/);
  if (m) return `${m[3]}${m[2]}${m[1]}`;
  m = texto.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (m) return `${m[1]}${m[2]}${m[3]}`;
  m = texto.match(/^(\d{8})$/);
  return m ? m[1] : null;
};

// Primeira e última ocorrência (dd/MM/yyyy) dentre as datas informadas
export const periodoOcorrencias = (datas: any[]): { primeira?: string, ultima?: string } => {
  const chaves = datas.map(chaveData).filter((c): c is string => !!c).sort();
  const formatar = (c?: string) => c ? `${c.substring(6, 8)}/${c.substring(4, 6)}/${c.substring(0, 4)}` : undefined;
  return { primeira: formatar(chaves[0]), ultima: formatar(chaves[chaves.length - 1]) };
};

// Valor monetário no formato brasileiro ("1.234,56", "R$ 1.234,56") ou numérico
export const valorBR = (valor: any): number => {
  if (valor === undefined || valor === null || valor === '') return 0;
  if (typeof valor === 'number') return valor;
  const texto = String(valor).replace(/[^\d,.-]/g, '');
  const numero = texto.includes(',') ? Number(texto.replace(/\./g, '').replace(',', '.')) : Number(texto);
  return isNaN(numero) ? 0 : numero;
};

// Card de resumo por categoria de restrição: vermelho quando há ocorrências, azul quando não há.
// Datas chegam já formatadas (dd/MM/yyyy); valor é omitido quando a categoria não tem valor monetário.
export default function CardResumo({
  titulo,
  quantidade,
  valor,
  primeira,
  ultima,
  destacar = true,
}: {
  titulo: string;
  quantidade: number;
  valor?: number;
  primeira?: string;
  ultima?: string;
  destacar?: boolean;
}) {
  const { t } = useTranslation();
  return (
    <Card className='flex-1' style={{ backgroundColor: destacar && quantidade > 0 ? '#C70039' : '#2e2eb8', minWidth: '12rem' }}>
      <div className="flex-consulta flex-column gap-1">
        <span style={{ color: 'white' }} className="text-sm">{t(titulo)}</span>
        <span style={{ color: 'white' }} className="font-bold text-lg">{quantidade}</span>
        {valor !== undefined && <span style={{ color: 'white' }} className="text-sm">{formatValueReais(valor)}</span>}
        {primeira && <span style={{ color: 'white' }} className="text-xs">{t('Primeira')}: {primeira}</span>}
        {ultima && <span style={{ color: 'white' }} className="text-xs">{t('Última')}: {ultima}</span>}
      </div>
    </Card>
  );
}
